import React, { useContext } from 'react';
import { unimel_logo_ver } from '../assets';
import { AuthContext } from '../context/AuthContext';

const HomePage = ({ onNewDialogClick }) => {

  const { user, course } = useContext(AuthContext);


  return (
    <div className="w-full flex flex-col items-center bg-white mt-12 px-4 sm:px-6 lg:px-10" style={{"height": "inherit"}}>
      <h3 className="mb-12 text-center">
        {user ? `Bienvenido '${user["Nombre Alumno"] || "ESTUDIANTE"}', soy Tutor IA, tu asistente virtual aquí para ayudarte con el curso '${course?.["NOMBRELARGOCURSO"] || ""}'.` : "ACCESO LIMITADO SOLO A ESTUDIANTES DE UNIMEL"}
      </h3>
      <img
        src={unimel_logo_ver}
        alt="Logo"
        className="h-24 mb-8"
      />
      <h1 className="text-2xl font-bold mb-4 sm:mb-6">Tutor IA</h1>
      <p className="text-md mb-4 sm:mb-6">Tutor de Inteligencia Artificial de la Universidad Metro Latinoamericana</p>
    </div>
  );
}

export default HomePage;